const BUSINESS_CARD_PUBLIC_ORIGIN = 'https://vcard.cldy.online';
const BUSINESS_CARD_PATH_PATTERN = /^\/(?:sg|au|global)\/[A-Za-z0-9]{16}\/?$/;
const MAX_BUSINESS_CARD_ERROR_LENGTH = 1000;
const MAX_BUSINESS_CARD_URL_LENGTH = 2048;
const BUSINESS_CARD_READY_MESSAGE_TYPE = 'business-card-ready';
const BUSINESS_CARD_ERROR_MESSAGE_TYPE = 'business-card-error';

export function normalizeBusinessCardUrl(value) {
  if (typeof value !== 'string'
    || value.length === 0
    || value.length > MAX_BUSINESS_CARD_URL_LENGTH) {
    return null;
  }

  let url;

  try {
    url = new URL(value);
  } catch (error) {
    return null;
  }

  if (url.origin !== BUSINESS_CARD_PUBLIC_ORIGIN
    || url.protocol !== 'https:'
    || url.username
    || url.password
    || url.port
    || url.search
    || url.hash
    || !BUSINESS_CARD_PATH_PATTERN.test(url.pathname)) {
    return null;
  }

  return url.href;
}

export function parseBusinessCardMessage(event, expectedSource, expectedOrigin) {
  if (!event
    || !expectedSource
    || typeof expectedOrigin !== 'string'
    || event.source !== expectedSource
    || event.origin !== expectedOrigin
    || Object.prototype.toString.call(event.data) !== '[object Object]') {
    return null;
  }

  const hasError = Object.prototype.hasOwnProperty.call(event.data, 'error');
  const hasCardUrl = Object.prototype.hasOwnProperty.call(event.data, 'cardurl');

  if (hasError === hasCardUrl) {
    return null;
  }

  if (hasError) {
    if (event.data.type !== BUSINESS_CARD_ERROR_MESSAGE_TYPE
      || typeof event.data.error !== 'string'
    ) {
      return null;
    }

    const message = event.data.error.trim();

    if (!message || message.length > MAX_BUSINESS_CARD_ERROR_LENGTH) {
      return null;
    }

    return {
      type: 'error',
      message,
    };
  }

  if (event.data.type !== BUSINESS_CARD_READY_MESSAGE_TYPE) {
    return null;
  }

  const url = normalizeBusinessCardUrl(event.data.cardurl);

  return url
    ? {
      type: 'ready',
      url,
    }
    : null;
}
